import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import type {
  PostConversationalPreviewSettingsErrors,
  PostConversationalPreviewSettingsProps,
  PostConversationalPreviewSettingsResult,
} from "./types";

export const postConversationalPreviewSettings = reactQueryMutationAdapter(
  [],
  createMutationFetcherFunctionWithShadowError<PostConversationalPreviewSettingsErrors>()(
    (props: PostConversationalPreviewSettingsProps): Promise<PostConversationalPreviewSettingsResult> => {
      return fetch(`/${props.appGroupId}/conversational/preview_settings`, "POST", {
        session_id: props.sessionId,
        user_message: props.userMessage,
        user_id: props.userId,
        conversational_setting: props.conversationalSetting,
      });
    }
  )
);
